module.exports = __webpack_public_path__ + "static/media/nerdwallet-credit-questions-answered.35f83a92.jpeg";